<section class="hero is-light">
    <div class="hero-body">
        <div class="container">
            <div class="section" style="padding: 0 1.5rem;">
                <h1 class="title" i18n="@@signUp">Registrazione</h1>
                <h2 class="subtitle" i18n="@@willsendEmail">Sarà inviata una email per completare l'iscrizione.</h2>
            </div>
        </div>
    </div>
</section>
<div class="container">
    <div class="section">
        <form #addSocioForm="ngForm" (ngSubmit)="addSocio()">
            <div class="tile is-ancestor">
                <div class="tile is-6 is-parent">
                    <div class="tile is-child box">
                        <div class="title is-5 has-text-primary is-uppercase border-bottom"
                            style="padding-bottom: 1.25rem;" i18n="@@personalData">
                            Anagrafica
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label" i18n="@@name"
                                    [ngClass]="{'has-text-danger' : nome1Field.invalid && (nome1Field.dirty || nome1Field.touched || addSocioForm.submitted)}">Nome</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" [(ngModel)]="socio.nome1" name="nome1FieldName"
                                            maxlength="127" required type="text" #nome1Field="ngModel"
                                            [ngClass]="{'is-danger' : nome1Field.invalid && (nome1Field.dirty || nome1Field.touched || addSocioForm.submitted)}">
                                    </div>
                                    <p class="help is-danger"
                                        *ngIf="nome1Field.invalid && (nome1Field.dirty || nome1Field.touched || addSocioForm.submitted)"
                                        i18n="@@dataRequired">
                                        Dato richiesto
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label" i18n="@@surname"
                                    [ngClass]="{'has-text-danger' : nome2Field.invalid && (nome2Field.dirty || nome2Field.touched || addSocioForm.submitted) }">Cognome</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" [(ngModel)]="socio.nome2" name="nome2FieldName"
                                            maxlength="127" required type="text" #nome2Field="ngModel"
                                            [ngClass]="{'is-danger' : nome2Field.invalid && (nome2Field.dirty || nome2Field.touched || addSocioForm.submitted)}">
                                    </div>
                                    <p class="help is-danger"
                                        *ngIf="nome2Field.invalid && (nome2Field.dirty || nome2Field.touched || addSocioForm.submitted)"
                                        i18n="@@dataRequired">
                                        Dato richiesto
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label" i18n="@@birthDate"
                                [ngClass]="{'has-text-danger' : dateField.invalid && (dateField.dirty || dateField.touched || addSocioForm.submitted)}"
                                >Data nascita</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control is-expanded">
                                        <p-calendar [(ngModel)]="dateModel"
                                         [inputStyleClass]="(dateField.invalid && (dateField.dirty || dateField.touched || addSocioForm.submitted)) ? 'input is-danger' : 'input'" 

                                        [yearRange]="yearRange" firstDayOfWeek="1" #dateField="ngModel" [required]="true"
                                            name="dateField" dateFormat="dd/mm/yy" [monthNavigator]="true"
                                            [yearNavigator]="true">

                                        </p-calendar>
                                    </div>
                                    <p class="help is-danger" *ngIf="dateField.invalid && (dateField.dirty || dateField.touched || addSocioForm.submitted)"
                                        i18n="@@dataRequired">
                                        Dato richiesto
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label" i18n="@@birthPlace"
                                    [ngClass]="{'has-text-danger' : luogoField.invalid && (luogoField.dirty || luogoField.touched || addSocioForm.submitted)}">Luogo
                                    nascita</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" [(ngModel)]="socio.luogoNascita" name="luogoFieldName"
                                            maxlength="50" required type="text" #luogoField="ngModel"
                                            [ngClass]="{'is-danger' : luogoField.invalid && (luogoField.dirty || luogoField.touched || addSocioForm.submitted)}">
                                    </div>
                                    <p class="help is-danger"
                                        *ngIf="luogoField.invalid && (luogoField.dirty || luogoField.touched || addSocioForm.submitted)"
                                        i18n="@@dataRequired">
                                        Dato richiesto
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label" i18n="@@sex">Sesso</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <input class="is-checkradio" id="mField" type="radio" name="mField" value="M"
                                        [(ngModel)]="socio.sesso">
                                    <label for="mField" i18n="@@maleLabel">M</label>
                                    <input class="is-checkradio" id="fField" type="radio" name="fField" value="F"
                                        [(ngModel)]="socio.sesso">
                                    <label for="fField" i18n="@@femaleLabel">F</label>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal"
                                [ngClass]="{'has-text-danger' : addressField.invalid && (addressField.dirty || addressField.touched || addSocioForm.submitted)}">
                                <label class="label" i18n="@@address"
                                    [ngClass]="{'has-text-danger' : addressField.invalid && (addressField.dirty || addressField.touched || addSocioForm.submitted)}">Indirizzo</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" [(ngModel)]="socio.indirizzo" name="indirizzoFieldName"
                                            maxlength="255" required type="text" #addressField="ngModel"
                                            [ngClass]="{'is-danger' : addressField.invalid && (addressField.dirty || addressField.touched || addSocioForm.submitted)}">
                                    </div>
                                    <p class="help is-danger"
                                        *ngIf="addressField.invalid && (addressField.dirty || addressField.touched || addSocioForm.submitted || addSocioForm.submitted)"
                                        i18n="@@dataRequired">
                                        Dato richiesto
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label" i18n="@@city"
                                    [ngClass]="{'has-text-danger' : cityField.invalid && (cityField.dirty || cityField.touched || addSocioForm.submitted)}">Città</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" [(ngModel)]="socio.citta" name="cittaFieldName"
                                            maxlength="100" required type="text" #cityField="ngModel"
                                            [ngClass]="{'is-danger' : cityField.invalid && (cityField.dirty || cityField.touched || addSocioForm.submitted)}">
                                    </div>
                                    <p class="help is-danger"
                                        *ngIf="cityField.invalid && (cityField.dirty || cityField.touched || addSocioForm.submitted)"
                                        i18n="@@dataRequired">
                                        Dato richiesto
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label" i18n="@@zone"
                                    [ngClass]="{'has-text-danger' : provinciaField.invalid && (provinciaField.dirty || provinciaField.touched || addSocioForm.submitted)}">Provincia</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" [(ngModel)]="socio.provincia" name="provinciaFieldName"
                                            maxlength="2" required type="text" #provinciaField="ngModel"
                                            [ngClass]="{'is-danger' : provinciaField.invalid && (provinciaField.dirty || provinciaField.touched || addSocioForm.submitted)}">
                                    </div>
                                    <p class="help is-danger"
                                        *ngIf="provinciaField.invalid && (provinciaField.dirty || provinciaField.touched || addSocioForm.submitted)"
                                        i18n="@@dataRequired">
                                        Dato richiesto
                                    </p>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <input class="input" [(ngModel)]="socio.cap" name="capFieldName" pInputText
                                            required pKeyFilter="pint" placeholder="CAP" i18n-placeholder="@@zipCode"
                                            type="text" #capField="ngModel" maxlength="10"
                                            [ngClass]="{'is-danger' : capField.invalid && (capField.dirty || capField.touched || addSocioForm.submitted)}">
                                    </div>
                                    <p class="help is-danger"
                                        *ngIf="capField.invalid && (capField.dirty || capField.touched || addSocioForm.submitted)"
                                        i18n="@@dataRequired">
                                        Dato richiesto
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label" i18n="@@country"
                                    [ngClass]="{'has-text-danger' : countryField.invalid && (countryField.dirty || countryField.touched || addSocioForm.submitted)}">Nazione</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control">
                                        <div class="select"
                                            [ngClass]="{'is-danger' : countryField.invalid && (countryField.dirty || countryField.touched || addSocioForm.submitted)}">
                                            <select style="width: 100%;" name="nazioneField"
                                                [(ngModel)]="socio.codStato" required #countryField="ngModel">
                                                <option *ngFor="let nazione of nazioni"
                                                    [ngValue]="nazione.twoLetterIsoCode">
                                                    {{nazione.twoLetterIsoCode}} - {{nazione.name}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <p class="help is-danger"
                                        *ngIf="countryField.invalid && (countryField.dirty || countryField.touched || addSocioForm.submitted)"
                                        i18n="@@dataRequired">
                                        Dato richiesto
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label i18n="@@taxCode"
                                    [ngClass]="{'has-text-danger' : (codFiscField.dirty || codFiscField.touched || addSocioForm.submitted) && (socio.codStato == 'IT' && !socio.codFiscale)}"
                                    class="label">Codice Fiscale</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" [(ngModel)]="socio.codFiscale" name="codFiscFieldName"
                                            type="text" maxlength="20" #codFiscField="ngModel"
                                            [required]="(socio.codStato == 'IT') ? '' : null"
                                            [ngClass]="{'is-danger' : (codFiscField.dirty || codFiscField.touched || addSocioForm.submitted) && (socio.codStato == 'IT' && !socio.codFiscale) }">
                                    </div>
                                    <p class="help is-danger"
                                        *ngIf="(codFiscField.dirty || codFiscField.touched || addSocioForm.submitted) && (socio.codStato == 'IT' && !socio.codFiscale)"
                                        i18n="@@dataRequired">
                                        Dato richiesto
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tile is-6 is-vertical is-parent">
                    <div class="tile is-child box">
                        <div class="title is-5 has-text-primary is-uppercase border-bottom"
                            style="padding-bottom: 1.25rem;">Contatti</div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label"
                                    [ngClass]="{'has-text-danger' : emailField.invalid && (emailField.dirty || emailField.touched || addSocioForm.submitted)}">Email</label>
                            </div>
                            <div class="field-body" style="flex-wrap: wrap;">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" [(ngModel)]="socio.email" name="emailFieldName" type="text"
                                            required email maxlength="50"
                                            [ngClass]="{'is-danger' : emailField.invalid && (emailField.dirty || emailField.touched || addSocioForm.submitted)}"
                                            #emailField="ngModel">
                                    </div>
                                    <p class="help is-danger"
                                        *ngIf="emailField.invalid && (emailField.dirty || emailField.touched || addSocioForm.submitted)"
                                        i18n="@@mailNotValid">
                                        Email non valida
                                    </p>
                                </div>
                                <div class="field">
                                    <div class="control" style="margin-top: .4em;">
                                        <input type="checkbox" class="is-checkradio" id="newsletterCheckbox"
                                            [(ngModel)]="socio.newsletter" [disabled]="!socio.email"
                                            name="newsLetterField">
                                        <label for="newsletterCheckbox">Newsletter</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label i18n="@@telephoneNumber" class="label">Telefono</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" [(ngModel)]="socio.telefono" name="telefonoFieldName"
                                            type="text" maxlength="255">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label i18n="@@mobilePhoneNumber" class="label">Cellulare</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" [(ngModel)]="socio.cellulare" name="cellulareFieldName"
                                            type="text" maxlength="20" #cellField="ngModel">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tile is-child box">
                        <div class="title is-5 has-text-primary is-uppercase border-bottom"
                            style="padding-bottom: 1.25rem;">Password</div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label"
                                    [ngClass]="{'has-text-danger' : passwordField.invalid && (passwordField.dirty || passwordField.touched || addSocioForm.submitted)}">Password</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" [(ngModel)]="socio.password" name="passwordFieldName"
                                            type="password" passwordValidator #passwordField="ngModel"
                                            [ngClass]="{'is-danger' : passwordField.invalid && (passwordField.dirty || passwordField.touched || addSocioForm.submitted)}">
                                    </div>
                                    <p class="help is-danger"
                                        *ngIf="passwordField.invalid && (passwordField.dirty || passwordField.touched || addSocioForm.submitted)"
                                        i18n="@@ruleNewPassword">
                                        La nuova password deve essere lunga almeno 8 caratteri e deve contenere almeno
                                        un numero, un carattere maiuscolo, un carattere speciale e un carattere
                                        minuscolo
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label i18n="@@confirmPassword" class="label"
                                    [ngClass]="{'has-text-danger' :
                   (confirmpasswordField.invalid || socio.confirmPassword != socio.password ) && (confirmpasswordField.dirty || confirmpasswordField.touched || addSocioForm.submitted)}">Conferma</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" [(ngModel)]="socio.confirmPassword"
                                            name="passwordFieldName" type="password" passwordValidator
                                            #confirmpasswordField="ngModel"
                                            [ngClass]="{'is-danger' :
                       (confirmpasswordField.invalid || socio.confirmPassword != socio.password ) && (confirmpasswordField.dirty || passwordField.touched || addSocioForm.submitted)}">
                                    </div>
                                    <p class="help is-danger"
                                        *ngIf="(confirmpasswordField.invalid || socio.confirmPassword != socio.password ) && (confirmpasswordField.dirty || confirmpasswordField.touched || addSocioForm.submitted)"
                                        i18n="@@ruleConfirmPassword">
                                        Conferma password e password devono contenere lo stesso valore
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tile is-child box">
                        <div class="title is-5 has-text-primary is-uppercase border-bottom"
                            style="padding-bottom: 1.25rem;">Convenzione</div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label i18n="@@association" class="label">Associazione</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control">
                                        <div class="select">
                                            <select style="width: 100%;" name="associazioneField"
                                                #associazioneField="ngModel" [ngModel]="socio.idAssociazione"
                                                (ngModelChange)="onChangeAssociazione($event)">
                                                <option [ngValue]="undefined" *ngIf="!socio.idAssociazione"
                                                    i18n="@@selectInsurance">--Seleziona associazione--</option>
                                                <option [ngValue]="undefined" *ngIf="socio.idAssociazione"
                                                    i18n="@@noInsurance">--Nessuna associazione--</option>
                                                <option *ngFor="let associazione of associazioni"
                                                    [ngValue]="associazione.id">
                                                    {{associazione.ragioneSociale}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label" i18n="@@cardAssociation"
                                    [ngClass]="{'has-text-danger' : socio.idAssociazione && tesseraAssociazioneField.invalid && (tesseraAssociazioneField.dirty || tesseraAssociazioneField.touched || addSocioForm.submitted)}">Tess.Ass.</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" [disabled]="!socio.idAssociazione"
                                            [(ngModel)]="socio.tesseraAssociazione" name="tesseraAssociazioneFieldName"
                                            type="text" #tesseraAssociazioneField="ngModel" maxlength="255"
                                            [ngClass]="{'is-danger' : socio.idAssociazione && tesseraAssociazioneField.invalid && (tesseraAssociazioneField.dirty || tesseraAssociazioneField.touched || addSocioForm.submitted)}"
                                            [required]="socio.idAssociazione ? '' : null">
                                    </div>
                                    <p class="help is-danger"
                                        *ngIf="socio.idAssociazione && tesseraAssociazioneField.invalid && (tesseraAssociazioneField.dirty || tesseraAssociazioneField.touched || addSocioForm.submitted)"
                                        i18n="@@dataRequired">
                                        Dato richiesto
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="notification is-primary is-size-7" style="padding-right: 1.5rem;">
                <h2 class="title is-4">Trattamento dei dati</h2>
                <p>
                    Dolomiti Emergency raccoglie i tuoi dati personali, in modo del tutto automatizzato e nel rispetto
                    della legge, per consentirti:<br />
                    l'iscrizione annuale all'Associazione<br />
                    la stipula della polizza 'Rimborso Spese per Soccorso e relativo Trasporto'<br />
                    la ricezione di nostre comunicazioni e newsletter<br />
                    di usufruire di tutti i futuri servizi previsti non ancora attivi<br />
                    Preso atto delle informazioni ricevute mediante la presente informativa resa dai titolari e
                    consapevole che ho piena libertà di scelta sul rilascio del mio consenso, ma che in caso di rifiuto
                    dello stesso per fini sotto indicati Dolomiti Emergency non potrà erogarmi i rispettivi servizi,
                    esprimo il mio consenso al trattamento per le seguenti finalità:<br />
                    raccolta e conservazione dei miei dati personali da parte dell'Ass. Dolomiti Emergency, al fine
                    della fornitura dei servizi dell'Ass. Dolomiti Emergency sopra indicati<br />
                    comunicazione a società appartenenti allo stesso Gruppo, a società o studi che svolgono attività
                    varie in materia contabile, amministrativa, legale, tributaria e finanziaria, a soggetti partner
                    coinvolti nella fornitura di servizi<br />
                    elaborazione dei miei dati personali per scopi amministrativi contabili<br />
                    In ogni momento i tuoi dati potranno essere consultati, modificati o cancellati ai sensi dell'art. 7
                    e 82 del D.Lgs. 196/2003 inviando una comunicazione scritta al Titolare del Trattamento:<br />
                    <br /><br />
                    Ass. Dolomiti Emergency,<br />
                    Via Cogonie n. 30, 32044 Pieve di Cadore (BL),<br />
                    Codice Fiscale/Partita IVA 92013050254.
                </p>
            </div>

            <div class="columns is-tablet">
                <div class="column">
                    <div class="field">
                        <input type="checkbox" class="is-checkradio" id="acceptCheckbox" [(ngModel)]="socio.accept"
                            name="acceptField">
                        <label for="acceptCheckbox" i18n="@@accpetCondition">Accetto tutte le condizioni</label>
                    </div>
                </div>
                <div class="column has-text-right">
                    <button type="submit" [disabled]="!socio.accept" class="button is-success is-large"
                        i18n="@@signUp">Registrati</button>
                </div>
            </div>
            <div class="notification is-success is-size-7" *ngIf="showSuccess" style="padding-right: 1.5rem;">
                <h2 class="title is-4" i18n="@@success">Successo</h2>
                <p i18n="@@socioCreated">
                    Socio creato, verrà inviata una mail all'indirizzo indicato
                </p>
            </div>
        </form>
    </div>
</div>